import { mdlProposalAdditionalBenfitsReq_Upgrade } from "./mdlProposalAdditionalBenfitsReq_Upgrade";

export class mdlProposalAddReq_Upgrade{
    public RegNo:string;
    public PolicyNo:string;
    public AdditionalBenifits:Array<mdlProposalAdditionalBenfitsReq_Upgrade>=new   Array<mdlProposalAdditionalBenfitsReq_Upgrade>(); 
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlProposalAddReq_Upgrade.ts